<template>
  <Modal
    :title="$t('new_version')"
    :form="{ data: formData, endpoint: `collections/${sharedCollectionHashid}/personalisations` }"
    :confirm-label="$t('create')"
    @confirm="onSuccess"
  >
    <InputGroup
      :label="$t('name')"
      name="name"
      :description="$t('version_name_example')"
    >
      <TextInput
        v-model="formData.name"
        name="name"
      />
    </InputGroup>
  </Modal>
</template>

<script setup lang="ts">
import { parseURL } from 'ufo'
import type { LandingPage } from '~/types/landing-page'

defineProps<{
  sharedCollectionHashid: string
}>()

const formData = reactive({
  name: ''
})

const { closeModal } = useModal()

const onSuccess = async (response: { data: LandingPage['personalisations'][number] }) => {
  const pathname = parseURL(response.data.landing_page_url).pathname
  await navigateTo(pathname)
  closeModal()
}
</script>
